var map = {
	"./assignment-details-service.js": 116,
	"./group-context-service.js": 805,
	"./paginated-instructional-items-service.js": 118,
	"./smart-group-rule-editor-service.js": 806,
	"./v3-passage-highlighting-service.js": 807,
	"./v3-vocab-highlighting-service.js": 808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 804;